module.exports = __webpack_public_path__ + "media/images/lb/624-0b9f0a9d8eb7e22cabdab172f5fe1665.svg";